<template>
  <div class="animated fadeIn">
    <div class="kt-portlet kt-portlet--mobile" style="position: relative">
      <div class="kt-portlet__body kt-portlet__body--fit" ref="cntActivity">
        <div class="m-4">
          <div style="overflow: auto">
            <b-table
              id="user-activity-manual-table"
              :busy.sync="isBusy"
              show-empty
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :hover="true"
              :striped="true"
              stacked="md"
              v-model="copy"
              :items="provider"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              @row-clicked="rowClicked"
              tbody-tr-class="tr-pointer"
              v-columns-resizable="{ afterResize: columnsWidthChanged }"
            >
              <template v-slot:empty="scope">
                <div class="text-center">{{ $t(scope.emptyText) }}</div>
              </template>

              <template v-slot:head(cnp)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(name)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(surname)="data">{{
                $t(data.label)
              }}</template>
              <template v-slot:head(eshop_id)="data">{{
                $t(data.label)
              }}</template>
              <template v-slot:head(starting_at)="data">{{
                $t(data.label)
              }}</template>
              <template v-slot:head(ending_at)="data">{{
                $t(data.label)
              }}</template>
              <template v-slot:head(duration)="data">{{
                $t(data.label)
              }}</template>

              <template v-slot:head(euser_id)="data">{{
                $t(data.label)
              }}</template>
              <template v-slot:head(reason)="data">{{
                $t(data.label)
              }}</template>
              <template v-slot:cell(reason)="data">{{
                $t(data.value)
              }}</template>

              <template v-slot:cell(eshop_id)="data">
                <span v-if="data.value.to">
                  <router-link :to="`/shops/${data.value.to}`">{{
                    data.value.name
                  }}</router-link>
                </span>
                <span v-else>{{ data.value.name }}</span>
              </template>

              <template v-slot:cell(euser_id)="data">
                <span v-if="data.value.to">
                  <router-link :to="`/users/${data.value.to}`">{{
                    data.value.name
                  }}</router-link>
                </span>
                <span v-else>{{ data.value.name }}</span>
              </template>

              <template v-slot:cell(starting_at)="data">
                <span>{{ mom_unix(data.value).format(tableDateLong) }}</span>
              </template>
              <template v-slot:cell(ending_at)="data">
                <span>{{ mom_unix(data.value).format(tableDateLong) }}</span>
              </template>
              <template v-slot:cell(duration)="data">
                <span>{{
                  duration(data.item.starting_at, data.item.ending_at)
                }}</span>
              </template>

              <template v-slot:head(selected)>
                <label
                  class="kt-checkbox kt-checkbox--single kt-checkbox--all kt-checkbox--solid"
                >
                  <input
                    type="checkbox"
                    @click.stop
                    @change="selectAll"
                    v-model="checkAll"
                  />
                  <span></span>
                </label>
              </template>
              <template v-slot:cell(selected)="data">
                <label
                  class="kt-checkbox kt-checkbox--single kt-checkbox--all kt-checkbox--solid"
                >
                  <input
                    type="checkbox"
                    @click.stop
                    :value="data.item.eid"
                    v-model="selected"
                  />
                  <span></span>
                </label>
              </template>
            </b-table>
          </div>
          <div class="container-fluid">
            <div class="row">
              <div style="white-space: nowrap" class="my-2">
                <b-button
                  @click.stop="deleteSelected()"
                  size="sm"
                  class="mr-2 refresh"
                  variant="light"
                  v-if="selected.length"
                  >{{ $t("Delete") }}</b-button
                >
                <span class="pagination-sep" v-if="selected.length"></span>

                <PaginationSelect
                  v-model="perPage"
                  :options="paginationOpts"
                  variant="light"
                  size="sm"
                />
                <span>
                  &nbsp;
                  <i18n path="Showing {start}-{end} of {total} rows" tag="span">
                    <span slot="start">{{
                      (currentPage - 1) * perPage + 1
                    }}</span>
                    <span slot="end">{{ currentPage * perPage }}</span>
                    <span slot="total">{{ totalRows }}</span>
                  </i18n>
                </span>
                <b-button
                  size="sm"
                  @click.stop="
                    $root.$emit(
                      'bv::refresh::table',
                      'user-activity-manual-table'
                    )
                  "
                  class="ml-2 refresh"
                  variant="light"
                  :title="$t('Refresh')"
                >
                  <i class="icon-refresh"></i>
                </b-button>
              </div>
              <nav class="ml-auto mt-2">
                <b-pagination
                  size="md"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  v-model="currentPage"
                />
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { errorConf } from "@/shared/notifications";
import tableMixin from "@/shared/mixins/table.mixin";
import PaginationSelect from "@/components/PaginationSelect";
import DropdownColumns from "@/components/DropdownColumns";
import TableFilters from "@/components/TableFilters";
import BulkActionSelect from "@/components/BulkActionSelect";

export default {
  name: "user-activity",
  mixins: [tableMixin],
  props: ["cnp", "dateField", "dateStart", "dateEnd", "shopId"],
  components: {
    PaginationSelect,
    DropdownColumns,
    TableFilters,
    BulkActionSelect,
  },
  data: function () {
    return {
      tableName: "user-activity-manual",

      bulkAction: null,
      bulkActionOptions: [{ text: "Delete", field: "delete", value: true }],

      filterOptions: [],
      isBusy: false,
      sortBy: "starting_at",
      sortDesc: true,
      fields: [
        {
          key: "selected",
          selected: false,
          ignore: true,
          class: "mw-select",
          dpIgnore: true,
        },
        {
          key: "eid",
          label: "Id",
          sortable: false,
          class: "d-none",
          ignore: true,
        },
        {
          key: "cnp",
          label: "CNP",
          sortable: false,
          class: "",
          ignore: true,
        },
        {
          key: "name",
          label: "Name",
          sortable: false,
          class: "",
          ignore: true,
        },
        {
          key: "surname",
          label: "Surname",
          sortable: false,
          class: "",
          ignore: true,
        },
        {
          key: "eshop_id",
          label: "Shop Name",
          sortable: false,
          class: "",
          ignore: true,
        },
        { key: "starting_at", sortable: true, class: "", ignore: true },
        { key: "ending_at", sortable: true, class: "", ignore: true },
        { key: "duration", sortable: false, class: "", ignore: true },
        { key: "euser_id", label: "Username", sortable: false, class: "" },
        { key: "reason", sortable: false, class: "" },
      ],

      selected: [],
      allSelected: false,

      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: null,
      filterField: null,
      checkAll: false,
      copy: null,
      addLabel: "",
      preventLabel: true,
    };
  },
  methods: {
    refresh() {
      this.$root.$emit("bv::refresh::table", "user-activity-manual-table");
    },
    provider(ctx, callback) {
      const loading = this.$loading.open({
        container: this.$refs.cntActivity,
      });

      const paginationData = {
        rowsPerPage: this.perPage,
        page: this.currentPage,
      };

      if (this.filter && this.filterField) {
        paginationData.likeValues = [this.filter];
        paginationData.likeFields = [this.filterField];
      } else {
        paginationData.likeValues = [];
        paginationData.likeFields = [];
      }

      if (this.sortBy) {
        let sortBy = this.sortBy;
        paginationData.sortBy = [sortBy];
        paginationData.sortDirection = [this.sortDesc ? "DESC" : "ASC"];
      }

      paginationData.exactFields = ["cnp", "shop_id"];
      paginationData.exactValues = [[this.cnp], [this.shopId]];
      paginationData.dateField = this.dateField;
      paginationData.dateStart = moment(this.dateStart).startOf("month");
      paginationData.dateEnd = moment(this.dateEnd).endOf("month");

      const shopByID = this.$store.getters["cache/shopByID"];
      const userByID = this.$store.getters["cache/userByID"];

      Promise.all([
        this.$store.dispatch("cache/fetch", "users").catch((e) => e),
        this.$store.dispatch("cache/fetch", "shops").catch((e) => e),
      ]).finally(() => {
        this.$store
          .dispatch("userActivityManual/fetch", paginationData)
          .then((resp) => {
            this.totalRows = resp.data.total;
            resp.data.rows.forEach((item, index) => {
              if (item.eshop_id) {
                const data = shopByID(item.eshop_id);
                if (data) {
                  item.eshop_id = {
                    to: item.eshop_id,
                    name: data.name,
                  };
                } else {
                  item.eshop_id = {
                    to: null,
                    name:
                      item.eshop_id === "LOIQ6p7TaKDBIpfb-Pvm_A"
                        ? "-"
                        : item.eshop_id,
                  };
                }
              }

              if (item.euser_id) {
                const data = userByID(item.euser_id);
                if (data) {
                  item.euser_id = {
                    to: item.euser_id,
                    name: data.username,
                  };
                } else {
                  item.euser_id = {
                    to: null,
                    name:
                      item.euser_id === "LOIQ6p7TaKDBIpfb-Pvm_A"
                        ? "-"
                        : item.euser_id,
                  };
                }
              }
            });
            console.log(resp.data.rows);
            callback(resp.data.rows);
          })
          .catch((err) => {
            this.$bvToast.toast(
              this.$t(err.message),
              errorConf(this.$t("Error"))
            );
            this.totalRows = 0;
            callback([]);
          })
          .finally(() => {
            loading.close();
          });
      });
      // Must return null or undefined to signal b-table that callback is being used
      return null;
    },
    rowClicked(item, index, event) {},
    mom_unix(val) {
      return moment.unix(val / 1e9).utc();
    },
    duration(sd, ed) {
      sd = this.mom_unix(sd);
      if (ed === 0) {
        ed = moment();
      } else {
        ed = this.mom_unix(ed);
      }
      const dr = moment.duration(ed.diff(sd));
      let ret = "";
      if (dr.days()) {
        ret = `${dr.days()}d `;
      }
      if (dr.hours()) {
        ret = ret + `${dr.hours()}h `;
      }
      if (dr.minutes()) {
        ret = ret + `${dr.minutes()} min `;
      }
      if (dr.seconds()) {
        ret = ret + `${dr.seconds()} sec `;
      }
      return ret;
    },
    redirect() {},
    selectAll() {
      this.selected = [];
      this.copy.forEach((item) => {
        if (this.checkAll) {
          this.selected.push(item.eid);
        }
      });
    },
    deleteSelected() {
      const loading = this.$loading.open({
        container: this.$refs.cntActivity,
      });

      this.$store
        .dispatch("userActivityManual/delete", this.selected)
        .finally(() => {
          loading.close();
          this.allSelected = false;
          this.selected = [];
          this.refresh();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>


